import QrSvg from '@wojtekmaj/react-qr-svg';

import { toShortId } from '@rewardopl/utils/short_id';

import { CodeWrapper, ShortId, Wrapper } from './static_code.styles';

type StaticCodeProps = {
  color?: string;
  displayShortId?: boolean;
  id: string;
};

export default function StaticCode({ color, displayShortId = true, id }: StaticCodeProps) {
  const shortId = toShortId(id);

  return (
    <Wrapper>
      <CodeWrapper>
        <QrSvg bgColor="transparent" fgColor={color} value={shortId} />
      </CodeWrapper>
      {displayShortId ? <ShortId>{shortId}</ShortId> : null}
    </Wrapper>
  );
}
